{
	"no-face-detected": "Ingen ansikt oppdaget",
	"try-a-different-image": "Prøv med et annet bilde"
}
